export const TITLE = 'Idées cadeaux'
export const DESCRIPTION = 'Sélectionnez au moins un critère ci-dessous et laissez la magie opérer !'
